import { render, staticRenderFns } from "./payDirectly.vue?vue&type=template&id=a6f22ee2&scoped=true&"
import script from "./payDirectly.vue?vue&type=script&lang=js&"
export * from "./payDirectly.vue?vue&type=script&lang=js&"
import style0 from "./payDirectly.vue?vue&type=style&index=0&id=a6f22ee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f22ee2",
  null
  
)

export default component.exports